import { ReactSVG } from "react-svg"

const formatFeatureName = (key) =>
    key
        .replace(/_/g, " ")
        .replace(/\b\w/g, (l) => l.toUpperCase());

const getAccessStatus = (features) => {
    if (!features) {
        return { status: "No Access", badges: [] };
    }

    // If user has all access
    if (features.all) {
        return { status: "All Features", badges: [] };
    }

    // Collect all enabled features (including nested ones)
    const enabledFeatures = [];

    // Check top-level features
    const topLevelFeatures = ["dashboard", "fabrics", "style_accents", "report", "transactions"];
    topLevelFeatures.forEach(feature => {
        if (features[feature] === true) {
            enabledFeatures.push(feature);
        }
    });

    // Check nested master features
    if (features.master && typeof features.master === "object") {
        Object.entries(features.master).forEach(([key, value]) => {
            if (value === true) {
                enabledFeatures.push(`master.${key}`);
            }
        });
    }

    // Determine status
    if (enabledFeatures.length === 0) {
        return { status: "No Access", badges: [] };
    }

    return { status: "Some Features", badges: enabledFeatures };
};

const columns = [
    {
        name: "Style Name ",
        selector: (row) => row.season,
        sortable: true,
        maxWidth: "200px",
    },
    {
        name: "Main Style",
        selector: (row) => row.email,
        sortable: true,
        maxWidth: "200px",
    },
    // {
    //     name: "Sub Style",
    //     selector: (row) => row.phone_number,
    //     sortable: true,
    //     maxWidth: "200px",
    // },
    {
        name: "Status",
        selector: (row) => row.status,
        sortable: false,
    }
]

export default columns
